import { Navigate } from "react-router";

import { Skeleton } from "@/components/ui/skeleton";
import { useAuthStatus, useCurrentUser } from "@/features/auth/api/use-auth";
import { SessionUnavailableCard } from "@/features/auth/components/login-layout";
import { isSignedIn } from "@/features/auth/session/auth-status";
import { restoreSession } from "@/features/auth/session/restore";

import type { ReactNode } from "react";

type RequireAuthProps = {
  readonly children: ReactNode;
};

export function RequireAuth({ children }: RequireAuthProps) {
  const authStatus = useAuthStatus();
  const { data, isLoading, isError, refetch } = useCurrentUser();

  if (authStatus === "restoring") {
    return <Skeleton className="h-screen w-full" />;
  }

  if (authStatus === "unavailable") {
    return (
      <SessionUnavailableCard
        onRetry={() => {
          void restoreSession();
        }}
      />
    );
  }

  if (!isSignedIn(authStatus)) {
    return <Navigate replace to="/login" />;
  }

  if (isLoading) {
    return <Skeleton className="h-screen w-full" />;
  }

  if (isError || !data) {
    return (
      <SessionUnavailableCard
        onRetry={() => {
          void refetch();
        }}
      />
    );
  }

  return children;
}
